import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Subject, Observable, BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { HeaderService } from '../header/header.service';
import { AuthSession, LoginNavigationDecision } from './auth-session.model';
@Injectable({
  providedIn: 'root'
})
export class LoginService {
  data: any;
  url = environment.apiBase;
  apiBaseAraya = environment.apiBaseAraya;
  userID = null;
  private imgSource = new BehaviorSubject<any>('');
  imgUrl = this.imgSource.asObservable();

  constructor(private http: HttpClient, private router: Router,private headerService: HeaderService) {

  }

  updatedImgSource(imgUrl: any) {
    this.imgSource.next(imgUrl);
  }

  // Login service
  _userActionOccured: Subject<void> = new Subject();
  get userActionOccured(): Observable<void> {
    return this._userActionOccured.asObservable();
  }

  notifyUserAction() {
    this._userActionOccured.next();
  }

  login(body): Observable<any> {
    localStorage.setItem('email', body.email);
    var body1 = {
      email: body.email.trim(),
      password: body.password.trim()
    };

    return this.http.post(this.url + 'api/Account/Login', body1).pipe(
      tap(res => {
        body1 ={
          email:'',
          password:''
        }
        const session = this.createSessionFromResponse(res, body.email.trim());
        this.persistAuthSession(session);

        // StorageManager.

      })
    );
  }

  getImageUrl(submainName: string): Observable<any> {
    return this.http.get(this.url + `api/Account/GetLogoByDomainAsync/LogoByDomain/${submainName}`, { responseType: 'text' }).pipe(
      tap(res => {
      })
    );
  }

  getImageUrlClientId(clientId: string): Observable<any> {
    return this.http.get(this.url + `api/Clients/GetCustomerLogoByClientId/${clientId}`, { responseType: 'text' }).pipe(
      tap(res => {
      })
    );
  }


  logout() {
    localStorage.clear();
    sessionStorage.clear();
    this.updatedImgSource('');
    // this.router.navigate(['/']);
  }

  hasActiveSession(): boolean {
    return !!localStorage.getItem('token');
  }

  getStoredSession(): AuthSession | null {
    const token = localStorage.getItem('token');
    const roleId = localStorage.getItem('roleId');
    const clientId = localStorage.getItem('clientId');
    const clientName = localStorage.getItem('clientName');
    const firstName = localStorage.getItem('name');
    const userId = localStorage.getItem('userId');
    const isPwdVerified = localStorage.getItem('first');
    const email = localStorage.getItem('email') || undefined;

    // Client name can be empty for certain accounts (e.g. PBM/SSO); don't block a valid session on it.
    const normalizedClientName = clientName || '';

    if (!token || !roleId || !firstName || !userId || isPwdVerified == null) {
      return null;
    }

    return {
      token,
      roleId,
      clientId: this.parseClientId(clientId),
      clientName: normalizedClientName,
      firstName,
      userId,
      isPwdVerified: this.parseBoolean(isPwdVerified),
      email
    };
  }

  persistAuthSession(session: AuthSession): void {
    if (!session || !session.token) {
      throw new Error('Missing authentication session data.');
    }

    sessionStorage.clear();
    localStorage.setItem('clientId', session.clientId != null ? String(session.clientId) : '');
    localStorage.setItem('roleId', session.roleId);
    localStorage.setItem('token', session.token);
    localStorage.setItem('name', session.firstName);
    localStorage.setItem('first', String(session.isPwdVerified));
    localStorage.setItem('clientName', session.clientName);
    localStorage.setItem('userId', session.userId);

    if (session.email) {
      localStorage.setItem('email', session.email);
    }

    this.headerService.updatedCompanyName(session.clientName);
    this.notifyUserAction();
  }

  determinePostLoginNavigation(session: AuthSession): LoginNavigationDecision | null {
    if (!session) {
      return null;
    }

    const navFlag = localStorage.getItem('navFlag');
    if (navFlag !== undefined && navFlag !== null) {
      return {
        commands: ['adjuster/memberprofile']
      };
    }

    const isPwdVerified = session.isPwdVerified;

    if (session.roleId === '1') {
      if (!isPwdVerified) {
        return { commands: ['changepassword'] };
      }
      return { commands: ['admin/home'], showLoader: true };
    }

    if (session.roleId === '2') {
      if (!isPwdVerified) {
        return { commands: ['changepassword'] };
      }
      return { commands: ['client/home'] };
    }

    // Default: adjuster or other roles
    if (!isPwdVerified) {
      return { commands: ['changepassword'] };
    }

    const isFromPreApproved = localStorage.getItem('isFromPreAppoved');
    if (isFromPreApproved) {
      return { commands: ['adjuster/PendingAuthorizations'] };
    }

    return { commands: ['adjuster/home'] };
  }

  private createSessionFromResponse(res: any, email?: string): AuthSession {
    if (!res) {
      throw new Error('Invalid authentication response.');
    }

    const firstName = res.firstName || res.FirstName || '';
    const roleId = res.roleId != null ? String(res.roleId) : '';
    const clientName = res.clientName || res.ClientName || '';
    const userId = res.userId || res.UserId || '';
    const isPwdVerifiedValue =
      res.isPwdVerified !== undefined ? res.isPwdVerified : res.IsPwdVerified;
    const clientIdValue =
      res.clientId !== undefined ? res.clientId : res.ClientId;

    const token = res.token || res.Token;

    return {
      token,
      firstName,
      roleId,
      clientId: this.parseClientId(clientIdValue),
      clientName,
      userId,
      isPwdVerified: this.parseBoolean(isPwdVerifiedValue),
      email: email || localStorage.getItem('email') || undefined
    };
  }

  private parseClientId(clientId: any): number | string | null {
    if (clientId === null || clientId === undefined || clientId === '') {
      return null;
    }

    const parsed = Number(clientId);
    return Number.isNaN(parsed) ? clientId : parsed;
  }

  private parseBoolean(value: any): boolean {
    if (typeof value === 'boolean') {
      return value;
    }
    if (typeof value === 'string') {
      return value === 'true' || value === '1';
    }
    if (typeof value === 'number') {
      return value === 1;
    }
    return false;
  }
}
